/** @format */
import React, { FunctionComponent, useState } from 'react'
import styled from 'styled-components'
import { Input } from '@king-design/react'

interface OwnProps {
  className?: string
  placeholder?: string
  value?: string
  onChange: (searchValue?: string) => void
}

const BatchSearchTextarea: FunctionComponent<OwnProps> = ({
  className,
  placeholder,
  value,
  onChange
}) => {
  const [row, setRow] = useState<number>(1)

  return (
    <Input
      type="textarea"
      placeholder={placeholder}
      rows={row}
      className={className}
      onChangeValue={(val: any) => {
        onChange(val)
      }}
      onBlur={e => {
        setRow(1)
      }}
      onFocus={e => {
        setRow(10)
      }}
    />
  )
}

export default styled(BatchSearchTextarea)`
  position: relative;
  height: 32px;
  .k-wrapper {
    position: absolute;
    top: 0;
    left: 9;
    z-index: 999;
    .k-textarea {
      resize: none;
      padding: 4px 16px;
      line-height: 22px;
    }
  }
`
